import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { useMediaQuery } from 'beautiful-react-hooks';

import MainFooter from "../layout/MainFooter";
import MainHeader from "../layout/MainHeader";
import AreasList from "./AreasList";
import Infotip from "../global/Infotip";

const Areas = (props) => {
    const isMobile = useMediaQuery('(max-width: 599px)');
    const isTablet = useMediaQuery('(max-width: 1023px)');
    
    document.body.className = 'survey survey--areas';
    
    return (
        <Fragment>
            <MainHeader>
                {props.testsDone === 0 &&
                    <h2>Obszary</h2>
                }
                {(props.testsDone === 1 || props.testsDone === 2) &&
                    <h2>Wybierz następny obszar</h2>
                }
                {props.testsDone === 3 &&
                    <h2>Odpowiedz na pytania z ostatniego obszaru</h2>
                }
                <p style={{opacity: props.testsDone ? 0 : 1, display: (isTablet && !!props.testsDone) ? 'none' : 'block'}}>
                    Pytania podzieliliśmy na 4 obszary. Wybierz obszar, od którego chcesz zacząć.
                    Po każdym pytaniu zobaczysz jak odpowiadali na nie inni*, a na koniec otrzymasz podsumowanie
                    wyników.
                </p>
            </MainHeader>
            <AreasList />
            <MainFooter addClass={isMobile ? 'single--center' : ''}>
                <div className="info" />
                <div className="text">
                    <Infotip>
                        <small>*Uczestnicy sondażu zrealizowanego na ogólnopolskiej próbie Polaków (09.2019)</small>
                    </Infotip>
                </div>

                <div className="actions">
                    {props.testsDone > 0 &&
                        <Link to="/survey/results" className="btn btn--secondary">
                            Przejdź do podsumowania
                        </Link>
                    }
                </div>
            </MainFooter>
        </Fragment>
    );
}

const mapStateToProps = state => {
    return {
        test: state.test,
        survey: state.survey,
        testsDone: state.globals.testsDone,
    };
};

export default connect(mapStateToProps)(Areas);


// WEBPACK FOOTER //
// ./sources/js/components/Areas/index.js